export default __webpack_public_path__ + "static/media/file.ace848b2.svg";